const getDataDogConfig = (): { clientToken: string; site: string; sampleRate: number; forwardErrorsToLogs: boolean; service: string } => ({
    clientToken: process.env.DATADOG_TOKEN as string,
    site: 'datadoghq.com',
    sampleRate: 100,
    forwardErrorsToLogs: false,
    service: process.env.NAME as string,
});

export default getDataDogConfig;
